import { ReactNode } from 'react';
import { createShallowStore, createStoreWithSubscribe } from '@frontend/store';
import { MessageInsightsAccordionType } from '../types';

export type MessageData = {
  messageId: string;
  threadId: string;
  locationId: string;
  content?: string;
  createdAt?: string;
  escalationSubject?: string;
  escalationBody?: string;
  outcomeBubbleNode?: ReactNode;
};

type OpenContextParams = {
  message: MessageData;
  opts?: {
    defaultAccordion?: MessageInsightsAccordionType;
    isDemoAccount?: boolean;
  };
};

type PanelState = {
  selectedMessage: MessageData | null;
  defaultAccordion: MessageInsightsAccordionType;
  isDemoAccount: boolean;
};

type MessageInsightsPanelActions = {
  closeContext: () => void;
  openContext: (params: OpenContextParams) => void;
};

export interface MessageInsightsPanelStore extends PanelState, MessageInsightsPanelActions {}

const initialState: PanelState = {
  selectedMessage: null,
  defaultAccordion: 'messageIntel',
  isDemoAccount: false,
};

export const useMessageInsightsPanelStore = createStoreWithSubscribe<MessageInsightsPanelStore>(
  (set) => ({
    ...initialState,

    closeContext: () => {
      set({ selectedMessage: null });
    },

    openContext: ({ message, opts = {} }: OpenContextParams) => {
      set({
        selectedMessage: message,
        defaultAccordion: opts.defaultAccordion ?? 'messageIntel',
        isDemoAccount: opts.isDemoAccount ?? false,
      });
    },
  }),
  {
    name: 'MessageInsightsPanelStore',
    trace: true,
  }
);

export const useMessageInsightsPanelShallowStore = createShallowStore(useMessageInsightsPanelStore);
